import { stringify } from 'query-string';
import { apiFetch } from './utils/api';

import { costReportMock } from '../store/entities/mocks/costReport';

export const costReports = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });
    const url = `/v2/qlik/cost-report?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
